import { render, staticRenderFns } from "./SuccessCard.vue?vue&type=template&id=3758a236&scoped=true"
import script from "./SuccessCard.vue?vue&type=script&lang=ts"
export * from "./SuccessCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758a236",
  null
  
)

export default component.exports